import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';
import { takeLatest, select, put, call, take } from 'redux-saga/effects';
import * as userAPI from '../lib/api/user';
import { logout } from './account';
import createRequestSaga, {
  createRequestActionTypes,
} from '../lib/createRequestSaga';

import { initUserConditions, changeUserCondition } from './shampoo';
import constants from 'containers/shampoo/constants';

// Action Type 정의
const INIT_FIELD = 'user/INIT_FIELD';
const CHANGE_FIELD = 'user/CHANGE_FIELD';
const CHANGE_SUB_FIELD = 'user/CHANGE_SUB_FIELD';
const INITIALIZE_FORM = 'user/INITIALIZE_FORM';
const CHANGE_ACTIVE_USER = 'user/CHANGE_ACTIVE_USER';
const INIT_FIELD_TEL = 'user/INIT_FIELD_TEL';
export const CHANGE_USER_QUIZ = 'user/CHANGE_USER_QUIZ';
const DOWNLOAD_COUPON_AFTER_LOGIN = 'user/DOWNLOAD_COUPON_AFTER_LOGIN';

const [GET_USERS, GET_USERS_SUCCESS, GET_USERS_FAILURE] =
  createRequestActionTypes('user/GET_USERS');

const [GET_USER, GET_USER_SUCCESS, GET_USER_FAILURE] =
  createRequestActionTypes('user/GET_USER');
const [MODIFY_USER, MODIFY_USER_SUCCESS, MODIFY_USER_FAILURE] =
  createRequestActionTypes('user/MODIFY_USER');

const [CHECK_NICKNAME, CHECK_NICKNAME_SUCCESS, CHECK_NICKNAME_FAILURE] =
  createRequestActionTypes('user/CHECK_NICKNAME');

const [CHECK_PHONE, CHECK_PHONE_SUCCESS, CHECK_PHONE_FAILURE] =
  createRequestActionTypes('user/CHECK_PHONE');
const [VERIFY_PHONE, VERIFY_PHONE_SUCCESS, VERIFY_PHONE_FAILURE] =
  createRequestActionTypes('user/VERIFY_PHONE');

const [
  VERIFY_PHONE_RESEND,
  VERIFY_PHONE_RESEND_SUCCESS,
  VERIFY_PHONE_RESEND_FAILURE,
] = createRequestActionTypes('user/VERIFY_PHONE_RESEND');

const [VERIFY_CODE, VERIFY_CODE_SUCCESS, VERIFY_CODE_FAILURE] =
  createRequestActionTypes('user/VERIFY_CODE');

const [
  ADD_USER_BASIC_INFO,
  ADD_USER_BASIC_INFO_SUCCESS,
  ADD_USER_BASIC_INFO_FAILURE,
] = createRequestActionTypes('user/ADD_USER_BASIC_INFO');
const [ADD_USER_PROFILE, ADD_USER_PROFILE_SUCCESS, ADD_USER_PROFILE_FAILURE] =
  createRequestActionTypes('user/ADD_USER_PROFILE');
const [
  ADD_USER_FINALIZE,
  ADD_USER_FINALIZE_SUCCESS,
  ADD_USER_FINALIZE_FAILURE,
] = createRequestActionTypes('user/ADD_USER_FINALIZE');

const [DOWNLOAD_COUPON, DOWNLOAD_COUPON_SUCCESS, DOWNLOAD_COUPON_FAILURE] =
  createRequestActionTypes('user/DOWNLOAD_COUPON');

const [
  GET_VALID_COUPON_LIST,
  GET_VALID_COUPON_LIST_SUCCESS,
  GET_VALID_COUPON_LIST_FAILURE,
] = createRequestActionTypes('user/GET_VALID_COUPON_LIST');

// ================== Action 생성 ================== //
export const initField = createAction(INIT_FIELD, ({ form, key }) => ({
  form,
  key,
}));
export const initFieldTel = createAction(INIT_FIELD_TEL);

export const changeField = createAction(
  CHANGE_FIELD,
  ({ form, key, value }) => ({
    form, // add
    key, // nickname, birthyear, ...
    value, // 실제 바꾸려는 값
  }),
);
export const changeSubField = createAction(
  CHANGE_SUB_FIELD,
  ({ form, key, sub, value }) => ({
    form, // add
    key, // preference, ...
    sub, // shampoo_1 ...
    value, // 실제 바꾸려는 값
  }),
);

// ================== Handlers ================== //
export const initializeForm = createAction(INITIALIZE_FORM, (form) => form);
export const changeActiveUser = createAction(
  CHANGE_ACTIVE_USER,
  (activeUserId) => activeUserId,
);
export const getUsers = createAction(GET_USERS, (token) => token);

export const getUser = createAction(GET_USER, (userId) => userId);
export const checkNickname = createAction(
  CHECK_NICKNAME,
  (nickname) => nickname,
);
export const checkPhone = createAction(CHECK_PHONE, (phone) => phone);
export const verifyPhone = createAction(
  VERIFY_PHONE,
  ({ temporary_id, phone_number }) => ({ temporary_id, phone_number }),
);
export const verifyPhoneResend = createAction(
  VERIFY_PHONE_RESEND,
  ({ temporary_id, phone_number }) => ({ temporary_id, phone_number }),
);
export const verifyCode = createAction(
  VERIFY_CODE,
  ({ temporary_id, verification_code }) => ({
    temporary_id,
    verification_code,
  }),
);
export const addUserBasicInfo = createAction(
  ADD_USER_BASIC_INFO,
  ({ temporary_id, basic_info }) => ({
    temporary_id,
    basic_info,
  }),
);
export const addUserProfile = createAction(
  ADD_USER_PROFILE,
  ({ temporary_id, profile_info }) => ({
    temporary_id,
    profile_info,
  }),
);
export const addUserFinalize = createAction(
  ADD_USER_FINALIZE,
  (temporary_id) => temporary_id,
);
export const downloadCoupon = createAction(
  DOWNLOAD_COUPON,
  ({ coupon_id, category }) => ({ coupon_id, category }),
);
export const downloadCouponAfterLogin = createAction(
  DOWNLOAD_COUPON_AFTER_LOGIN,
  ({ coupon_id }) => ({ coupon_id }),
);
export const getValidCouponList = createAction(GET_VALID_COUPON_LIST);

// saga 생성
export const getUsersSaga = createRequestSaga(GET_USERS, userAPI.getUsers);
export const getUserSaga = createRequestSaga(GET_USER, userAPI.getUser);
export const checkNicknameSaga = createRequestSaga(
  CHECK_NICKNAME,
  userAPI.checkNickname,
);
export const checkPhoneSaga = createRequestSaga(
  CHECK_PHONE,
  userAPI.checkPhone,
);
export const verifyPhoneSaga = createRequestSaga(
  VERIFY_PHONE,
  userAPI.verifyPhone,
);
export const verifyPhoneResendSaga = createRequestSaga(
  VERIFY_PHONE_RESEND,
  userAPI.verifyPhoneResend,
);
export const verifyCodeSaga = createRequestSaga(
  VERIFY_CODE,
  userAPI.verifyCode,
);
export const addUserBasicInfoSaga = createRequestSaga(
  ADD_USER_BASIC_INFO,
  userAPI.addUserBasicInfo,
);
export const addUserProfileSaga = createRequestSaga(
  ADD_USER_PROFILE,
  userAPI.addUserProfile,
);
export const addUserFinalizeSaga = createRequestSaga(
  ADD_USER_FINALIZE,
  userAPI.addUserFinalize,
);

export const modifyUser = createAction(MODIFY_USER, ({ user_id, form }) => ({
  user_id,
  form,
}));
const modifyUserSaga = createRequestSaga(MODIFY_USER, userAPI.modifyUser);

function* downloadCouponAfterLoginSaga(action) {
  yield take(GET_USERS_SUCCESS);

  yield put({
    type: DOWNLOAD_COUPON,
    payload: action.payload,
  });
}

function* downloadCouponSaga(action) {
  const updateIssuedCouponsInLocalStorage = (user_id, coupon_id) => {
    let issuedCoupons = localStorage.getItem('issuedCoupons');
    issuedCoupons = issuedCoupons
      ? JSON.parse(issuedCoupons)
      : { [user_id]: [] };

    issuedCoupons = Object.assign(issuedCoupons, {
      [user_id]: [
        coupon_id,
        ...(issuedCoupons?.[user_id] ? issuedCoupons[user_id] : []),
      ],
    });

    localStorage.setItem('issuedCoupons', JSON.stringify(issuedCoupons));
  };

  try {
    const users = yield select((state) => state.user.users);

    if (!users) {
      return;
    }
    // 탈퇴한 사용자 경우
    if (users?.length === 0) {
      logout();
      return;
    }

    const activeUser = users[0];

    const {
      data: { item, error, msg },
    } = yield call(userAPI.downloadCoupon, {
      coupon_id: action.payload.coupon_id,
      user_id: activeUser.user_id,
      category: action.payload?.category || null,
    });

    if (error) {
      yield put({
        type: DOWNLOAD_COUPON_FAILURE,
        payload: msg,
      });
      if (msg === 'User can download the coupon only once.') {
        updateIssuedCouponsInLocalStorage(
          activeUser.user_id,
          action.payload.coupon_id,
        );
      }
      return;
    }

    // 로컬스토리지에 쿠폰발급받은 사실 저장
    updateIssuedCouponsInLocalStorage(
      activeUser.user_id,
      action.payload.coupon_id,
    );

    yield call(getValidCouponListSaga);
  } catch (error) {
    yield put({
      type: DOWNLOAD_COUPON_FAILURE,
      payload: '내부 문제가 생겼어요 :(',
    });
  }
}

function* getValidCouponListSaga() {
  try {
    const users = yield select((state) => state.user.users);

    if (!users) {
      return;
    }
    // 탈퇴한 사용자 경우
    if (users?.length === 0) {
      logout();
      return;
    }

    const activeUser = users[0];

    const {
      data: { items, error, msg },
    } = yield call(userAPI.getValidCouponList, {
      user_id: activeUser.user_id,
    });
    if (error) {
      yield put({
        type: GET_VALID_COUPON_LIST_FAILURE,
        payload: msg,
      });
      return;
    }
    yield put({
      type: GET_VALID_COUPON_LIST_SUCCESS,
      payload: items,
    });
  } catch (error) {
    yield put({
      type: GET_VALID_COUPON_LIST_FAILURE,
      payload: '내부 문제가 생겼어요 :(',
    });
  }
}

export function* userSaga() {
  yield takeLatest(GET_USERS, getUsersSaga);
  yield takeLatest(GET_USER, getUserSaga);
  yield takeLatest(CHECK_NICKNAME, checkNicknameSaga);

  yield takeLatest(CHECK_PHONE, checkPhoneSaga);
  yield takeLatest(VERIFY_PHONE, verifyPhoneSaga);
  yield takeLatest(VERIFY_PHONE_RESEND, verifyPhoneResendSaga);
  yield takeLatest(VERIFY_CODE, verifyCodeSaga);

  yield takeLatest(ADD_USER_BASIC_INFO, addUserBasicInfoSaga);
  yield takeLatest(ADD_USER_PROFILE, addUserProfileSaga);
  yield takeLatest(ADD_USER_FINALIZE, addUserFinalizeSaga);
  yield takeLatest(MODIFY_USER, modifyUserSaga);
  yield takeLatest(GET_USERS_SUCCESS, getValidCouponListSaga);
  yield takeLatest(DOWNLOAD_COUPON, downloadCouponSaga);
  yield takeLatest(GET_VALID_COUPON_LIST, getValidCouponListSaga);
  yield takeLatest(DOWNLOAD_COUPON_AFTER_LOGIN, downloadCouponAfterLoginSaga);
}

const initialState = {
  add: {
    termsService: false,
    termsPrivacy: false,
    termsSensitivity: false,
    termsMarketing: false,
    birthyear: '',
    gender: '',
    nickname: '',
    phoneCountry: '82',
    phoneNumber: '',
    phoneNumberConfirm: '',
    // phoneNumber1: '10',
    // phoneNumber3: '',
    // 인증번호 코드 유저 입력
    verificationCode: '',

    // 인증번호 전송 유/무
    verificationCodeSent: false,

    // 인증번호 재전송 유/무
    verificationCodeResent: false,

    // 인증됌 --> 마지막 인증
    verified: null,

    hairlossType: '',
    scalpType: '',
    userAdded: null,
    phoneDuplicated: null,
    basicInfoAdded: null,
    profileAdded: null,
    nicknameDuplicated: null,
  },
  users: null,
  coupons: [],
  modifyForm: null,
  activeUserId: null,
  checkError: null,
  resultMsg: null,
  error: null,
};

export default handleActions(
  {
    [INIT_FIELD]: (state, { payload: { form, key } }) =>
      produce(state, (draft) => {
        draft[form][key] = initialState[form][key]; // 예: state.form.nickname을 초기 상태로 바꾼다
      }),
    [CHANGE_FIELD]: (state, { payload: { form, key, value } }) =>
      produce(state, (draft) => {
        draft[form][key] = value; // 예: state.form.nickname을 바꾼다
      }),
    [CHANGE_SUB_FIELD]: (state, { payload: { form, key, sub, value } }) =>
      produce(state, (draft) => {
        draft[form][key][sub] = value; // 예: state.form.preference.shampoo_1을 바꾼다
      }),
    [INITIALIZE_FORM]: (state, { payload: form }) => ({
      ...state,
      [form]: initialState[form],
      checkError: null, // 폼 전환 시 회원 인증 에러 초기화
    }),
    [INIT_FIELD_TEL]: (state) => ({
      ...state,
      add: {
        ...state.add,
        phoneNumber: '',
        phoneNumberConfirm: '',
        verificationCodeSent: false,
        verificationCodeResent: false,
      },
    }),
    [CHANGE_ACTIVE_USER]: (state, { payload: activeUserId }) => ({
      ...state,
      activeUserId: activeUserId,
    }),
    // user list 불러오기 성공
    [GET_USERS_SUCCESS]: (state, { payload: users }) => ({
      ...state,
      users: users.users,
    }),
    // user list 불러오기 실패
    [GET_USERS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      users: null,
      checkError: error,
    }),
    // user 정보 불러오기 성공
    [GET_USER_SUCCESS]: (state, { payload: user }) => ({
      ...state,
      modifyForm: user && user.user ? user.user : null,
    }),
    // user 정보 불러오기 실패
    [GET_USER_FAILURE]: (state, { payload: error }) => ({
      ...state,
      checkError: error,
    }),
    // 닉네임 중복검사 성공 (available 결과 값 -> true/false)
    [CHECK_NICKNAME_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      add: { ...state.add, nicknameDuplicated: res.duplicated },
    }),
    // 닉네임 중복검사 실패
    [CHECK_NICKNAME_FAILURE]: (state, { payload: error }) => ({
      ...state,
      checkError: error,
    }),
    // 폰번호 중복검사 성공 (available 결과 값 -> true/false)
    [CHECK_PHONE_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      add: { ...state.add, phoneDuplicated: res.duplicated },
    }),
    // 폰번호 중복검사 실패
    [CHECK_PHONE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      checkError: error,
    }),
    // 휴대폰 번호 검증을 위한 인증번호 전송 성공
    [VERIFY_PHONE_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      add: { ...state.add, verificationCodeSent: true },
    }),
    // 휴대폰 번호 검증을 위한 인증번호 전송 실패
    [VERIFY_PHONE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      checkError: error,
    }),
    // 휴대폰 번호 검증을 위한 인증번호 재전송 성공
    [VERIFY_PHONE_RESEND_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      add: { ...state.add, verificationCodeResent: true },
    }),
    // 휴대폰 번호 검증을 위한 인증번호 재전송 실패
    [VERIFY_PHONE_RESEND_FAILURE]: (state, { payload: error }) => ({
      ...state,
      checkError: error,
    }),
    // 인증 번호 검증 성공
    [VERIFY_CODE_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      add: { ...state.add, verified: true },
      checkEerror: null,
    }),
    // 인증 번호 검증 실패
    [VERIFY_CODE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      add: { ...state.add, verified: false },
      checkError: error.response.data,
    }),

    // User의 basic info 등록 성공
    [ADD_USER_BASIC_INFO_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      add: { ...state.add, basicInfoAdded: true },
    }),
    // User의 basic info 등록 실패
    [ADD_USER_BASIC_INFO_FAILURE]: (state, { payload: error }) => ({
      ...state,
      checkError: error.response.data,
    }),

    // User의 profile 등록 성공
    [ADD_USER_PROFILE_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      add: { ...state.add, profileAdded: true },
      checkError: null,
    }),
    // User의 profile 등록  실패
    [ADD_USER_PROFILE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      checkError: error,
    }),

    // User 등록 성공
    [ADD_USER_FINALIZE_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      add: { ...state.add, userAdded: true },
    }),
    // User 등록 실패
    [ADD_USER_FINALIZE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),

    // user 정보 수정 성공
    [MODIFY_USER_SUCCESS]: (state, { payload: user }) => ({
      ...state,
      error: null,
    }),
    // user 정보 수정 실패
    [MODIFY_USER_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    //사용자 퀴즈 등록
    [CHANGE_USER_QUIZ]: (state, { data }) => ({
      ...state,
      users: [data],
    }),

    // 쿠폰 다운로드
    [DOWNLOAD_COUPON]: (state) => ({
      ...state,
      checkError: initialState.checkError,
      error: initialState.error,
    }),
    [DOWNLOAD_COUPON_FAILURE]: (state, { payload }) => ({
      ...state,
      checkError: payload,
      error: true,
    }),
    // 사용 가능한 쿠폰 리스트 불러오기
    [GET_VALID_COUPON_LIST]: (state) => ({
      ...state,
      checkError: initialState.checkError,
      error: initialState.error,
    }),
    [GET_VALID_COUPON_LIST_SUCCESS]: (state, { payload }) => ({
      ...state,
      coupons: payload,
      checkError: initialState.checkError,
      error: initialState.error,
    }),
    [GET_VALID_COUPON_LIST_FAILURE]: (state, { payload }) => ({
      ...state,
      checkError: payload,
      error: true,
    }),
  },
  initialState,
);

export const getUserId = (state) => {
  return state.user.users?.[0].user_id || null;
};

export const getUserName = (state) => {
  return state.user.users?.[0].nickname || null;
};
